import React from 'react';
import type { LevelKey, QuizQuestion } from '../types/quiz';
interface QuestionCardProps {
  question: QuizQuestion;
  selected?: LevelKey;
  onSelect: (key: LevelKey) => void;
}
export function QuestionCard({
  question,
  selected,
  onSelect
}: QuestionCardProps) {
  return <div data-id="element-100" data-mp="1gj81ec8i3jp4">
      <h2 className="font-serif text-2xl leading-snug text-violeta sm:text-3xl" data-id="element-101" data-mp="1gjhs621dduvv">
        {question.prompt}
      </h2>

      <ul className="mt-8 space-y-3" data-id="element-102" data-mp="1u9tlu5dls1p4">
        {question.options.map(option => {
        const isSelected = selected === option.key;
        return <li key={option.key} data-id="element-103" data-mp="1pdw53xyfgtbt">
              <button type="button" onClick={() => onSelect(option.key)} aria-pressed={isSelected} className={`flex w-full items-start gap-4 rounded-sm border px-5 py-4 text-left font-sans text-base transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta focus-visible:ring-offset-2 focus-visible:ring-offset-hueso ${isSelected ? 'border-violeta bg-violeta text-hueso' : 'border-noche/15 bg-white/60 text-noche hover:border-dorado hover:bg-dorado-tint/40'}`} data-id="element-104" data-mp="2492dusowr68u">
                <span className={`mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full border font-sans text-xs font-semibold ${isSelected ? 'border-dorado bg-dorado text-noche' : 'border-noche/25 text-noche/50'}`} aria-hidden="true" data-id="element-105" data-mp="3w8t1tpic9iv">
                  {option.key}
                </span>
                <span className="leading-relaxed" data-id="element-106" data-mp="rml5nhvp6ufs">{option.text}</span>
              </button>
            </li>;
      })}
      </ul>
    </div>;
}